"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module passwordRecoveryRoute
 * @description Baasic Platform Password Recovery Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Recover Password Recovery Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var PasswordRecoveryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordRecoveryRoute, _super);
    function PasswordRecoveryRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Password recovery route with route and query parameters.
        **/
        _this.passwordRecoveryRoute = 'recover-password';
        return _this;
    }
    /**
     * Parses recover-password route, recover-password route doesn't expose any additional properties.
     * @method
     * @example passwordRecoveryRoute.passwordRecovery();
     **/
    PasswordRecoveryRoute.prototype.passwordRecovery = function () {
        return _super.prototype.baseCreate.call(this, this.passwordRecoveryRoute, {});
    };
    /**
     * Parses recover-password change route, recover-password change route doesn't expose any additional properties.
     * @method
     * @example passwordRecoveryRoute.passwordChange();
     **/
    PasswordRecoveryRoute.prototype.passwordChange = function () {
        return _super.prototype.baseCreate.call(this, this.passwordRecoveryRoute + '/change', {});
    };
    var _a;
    PasswordRecoveryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], PasswordRecoveryRoute);
    return PasswordRecoveryRoute;
}(common_1.BaseRoute));
exports.PasswordRecoveryRoute = PasswordRecoveryRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
